import React, { Component } from "react";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "./section";

class Index1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    let scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  render() {
    return (
      <React.Fragment>
        {/* Importing Navbar */}
        <NavbarPage
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
        />

        {/* Importing section */}
        <Section
          title={"Customized Furniture Movers Solutions in Pretoria"}
          titleTemplate={"QikTruck"}
          titleSeparator={"-"}
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/furniture-movers-pretoria"}
          pageHeading={"Customized Furniture Movers Solutions in Pretoria"}
          pageSubHeading={"For your home or business"}
          pageDescription={"Get customized Furniture Movers solutions in Pretoria with our team of experienced drivers and state-of-the-art vehicles at QikTruck. We offer a range of delivery options to meet your specific needs, including same-day and next-day delivery. Sign up now and start enjoying the flexibility of our services."}
          pageDescription2={"Need customized Furniture Movers solutions in Pretoria? Look no further! Our team of experienced drivers and state-of-the-art vehicles at QikTruck offer a range of delivery options to meet your specific needs, including same-day and next-day delivery. Sign up now and start enjoying the flexibility of our services."}
        />

        {/* Importing Footer */}
        <Footer />
      </React.Fragment>
    );
  }
}

export default Index1;
